// removed by extract-text-webpack-plugin
module.exports = {"popup":"popup","popup_image":"popup_image","popup_little-pad":"popup_little-pad","popup__close":"popup__close","popup_video":"popup_video","popup_gallery-detail":"popup_gallery-detail","popup_video-list":"popup_video-list","mfp-content":"mfp-content","close-popup":"close-popup","svg-icon":"svg-icon"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_popup.scss
// module id = 279
// module chunks = 0